import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'

@inject('welcome')
@observer
export default class WelcomeProgress extends Component {

  percent() {
    const { welcome } = this.props
    return `${Math.round(welcome.progress * 100)}%`
  }

  render() {
    const { welcome } = this.props
    if (welcome.progress === 1) {
      return null
    }
    return (
      <div className="welcome-progress">
        <div
          className="welcome-progress-bar"
          style={{width: this.percent()}} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/Welcome/progress.js